import React from 'react';
import { CheckCircle2 } from 'lucide-react';
const LAW3_IMG = 'https://drwzpk38qkpfb.cloudfront.net/www.apc360zone.com/preview/uploaded/images/Redesigne%202024/law3.jpeg?opt=w3';
export function UseOfForceSection() {
  return <section className="py-16 md:py-24 bg-brand-black" data-id="element-785">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-786">
        <div className="text-center mb-12 md:mb-16 max-w-4xl mx-auto" data-id="element-787">
          <h2 className="text-3xl md:text-5xl font-extrabold text-brand-white uppercase tracking-wider mb-4" data-id="element-788">
            Use of Force Training, Guidance and Legal Consultation Services
          </h2>
          <div className="w-16 h-0.5 bg-brand-teal mx-auto" data-id="element-789" />
        </div>

        <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-790">
          <p className="text-lg text-brand-gray-300 leading-relaxed" data-id="element-791">
            We offer expert legal consulting services to police agencies,
            officers, and law firms seeking assistance with cases involving use
            of force incidents.
          </p>
          <p className="text-lg text-brand-gray-300 leading-relaxed mt-4" data-id="element-792">
            Our team of experienced consultants specializes in video analysis,
            reviewing specific use of force cases, and providing comprehensive
            reports that detail our professional assessments of how incidents
            occurred or how they could have been prevented.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-793">
          <div data-id="element-794">
            <img src={LAW3_IMG} alt="Use of Force Training" className="w-full h-auto border border-brand-gray-800" data-id="element-795" />
          </div>
          <div className="bg-brand-gray-900 p-8 border border-brand-gray-800" data-id="element-796">
            <h3 className="text-xl font-bold text-brand-white uppercase tracking-wide mb-6 flex items-center gap-3" data-id="element-797">
              <div className="w-8 h-0.5 bg-brand-teal" data-id="element-798" />
              Legal Services Include:
            </h3>
            <ul className="space-y-4" data-id="element-799">
              {['Comprehensive review of incident facts and circumstances', 'In-depth professional analysis of critical incidents, covering the entire event from initiation to resolution, with a detailed breakdown', '24/7 availability to support agencies and legal professionals in all investigative matters as required', 'Court litigation support and expert testimony upon request'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-800">
                  <CheckCircle2 className="w-5 h-5 text-brand-teal flex-shrink-0 mt-0.5" data-id="element-801" />
                  <span className="text-brand-gray-300 leading-relaxed" data-id="element-802">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}